import { z } from "zod";

/// URL search-params schema for `/$slug/feedback/$id`.
///
/// Note: the historical `tab` param was removed when the detail page
/// dropped its tab nav in favour of a single-page layout with the AI
/// analysis lifted into the right sidebar. The `.strict()` schema
/// silently strips any stale `?tab=...` from bookmarked URLs, so old
/// links continue to resolve cleanly to the new layout.
export const feedbackDetailSearchSchema = z
  .object({
    discussionFilter: z.enum(["newest", "mentioning-me"]).optional(),
  })
  .strict();
export type FeedbackDetailSearch = z.infer<typeof feedbackDetailSearchSchema>;
